import { getShortLanguage } from 'translations';

export const locale =
    localStorage.getItem('language') || getShortLanguage(window.navigator.language);
